module.exports = __webpack_public_path__ + "media/images/icons/scrolldown-f67a3f3fe7d1dff868a9e47b8fb3d529.svg";